

export const typeValues = [
  {
    value: "Sale",
    label: "Sale",
  },
  {
    value: "Refund",
    label: "Refund",
  },
];

export const statusValues = [
  {
    value: "Paid",
    label: "Paid",
  },
  {
    value: "Pending",
    label: "Pending",
  },
  {
    value: "Partially Paid",
    label: "Partially Paid",
  },
  {
    value: "Cancelled",
    label: "Cancelled",
  },
  {
    value: "Failed",
    label: "Failed",
  },
];
export const salesData  = {
  data: [
    {
      id: 1,
      user: "user1",
      receiptNumber: "R001",
      type: "Receipt",
      taxAmount: 5.0,
      discountAmount: 2.0,
      totalAmount: 100.0,
      status: "Paid",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      refunditems: [
        {
          id: 101,
          receiptNumber: "R101",
          type: "Refund",
          taxAmount: 0.0,
          discountAmount: 1.0,
          totalAmount: 10.0,
          status: "Paid",
          taxRate: 12,
          user: "user1",
          taxName: "gold",
          created_at: "2024-09-21 10:00:00",
          created_by: "Waqar",
        },
        {
          id: 102,
          receiptNumber: "R102",
          type: "Refund",
          taxAmount: 0.0,
          discountAmount: 2.0,
          user: "user1",
          totalAmount: 20.0,
          status: "Paid",
          taxRate: 12,
          taxName: "gold",
          created_at: "2024-09-22 11:00:00",
          created_by: "Waqar",
        },
      ],
    },
    {
      id: 2,
      user: "user1",

      receiptNumber: "R002",
      type: "Refund",
      taxAmount: 0.0,
      discountAmount: 10.0,
      totalAmount: 50.0,
      status: "Paid",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
    },
    {
      id: 3,
      receiptNumber: "R003",
      type: "Receipt",
      user: "user1",

      taxAmount: 4.5,
      discountAmount: 0.0,
      totalAmount: 200.0,
      status: "Unpaid",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
    },
    {
      id: 4,
      receiptNumber: "R004",
      type: "Receipt",
      taxAmount: 3.0,
      user: "user1",

      discountAmount: 1.0,
      totalAmount: 150.0,
      status: "Partially Paid",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
    },
    {
      id: 5,
      receiptNumber: "R005",
      type: "Refund",
      taxAmount: 0.0,
      user: "user1",

      discountAmount: 5.0,
      totalAmount: 30.0,
      status: "Paid",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
    },
    {
      id: 6,
      receiptNumber: "R006",
      type: "Receipt",
      taxAmount: 6.0,
      discountAmount: 3.0,
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      user: "user1",

      totalAmount: 250.0,
      status: "Paid",
    },
    {
      id: 7,
      receiptNumber: "R007",
      type: "Receipt",
      taxAmount: 2.0,
      user: "user1",

      discountAmount: 0.5,
      totalAmount: 75.0,
      status: "Unpaid",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
    },
    {
      id: 8,
      receiptNumber: "R008",
      type: "Refund",
      taxAmount: 0.0,
      user: "user1",

      discountAmount: 2.0,
      totalAmount: 10.0,
      status: "Paid",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
    },
    {
      id: 9,
      receiptNumber: "R009",
      type: "Receipt",
      user: "user1",

      taxAmount: 7.5,
      discountAmount: 0.0,
      totalAmount: 300.0,
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      status: "Paid",
      refunditems: [
        {
          id: 103,
          receiptNumber: "R103",
          type: "Refund",
          taxAmount: 0.0,
          user: "user1",
          discountAmount: 5.0,
          totalAmount: 30.0,
          status: "Paid",
          taxRate: 12,
          taxName: "gold",
          created_at: "2024-09-23 12:00:00",
          created_by: "Waqar",
        },
      ],
    },
    {
      id: 10,
      receiptNumber: "R010",
      type: "Receipt",
      taxAmount: 8.0,
      discountAmount: 4.0,
      totalAmount: 350.0,
      user: "user1",

      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",

      status: "Partially Paid",
    },
    {
      id: 11,
      receiptNumber: "R011",
      type: "Receipt",
      taxAmount: 5.5,
      user: "user1",

      discountAmount: 1.0,
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",

      totalAmount: 180.0,
      status: "Unpaid",
    },
    {
      id: 12,
      receiptNumber: "R012",
      user: "user1",

      type: "Refund",
      taxAmount: 0.0,
      discountAmount: 3.0,
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      taxRate: 12,
      taxName: "gold",

      totalAmount: 20.0,
      status: "Paid",
    },
    {
      id: 13,
      receiptNumber: "R013",
      type: "Receipt",
      user: "user1",

      taxAmount: 9.0,
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",

      discountAmount: 5.0,
      totalAmount: 400.0,
      status: "Paid",
    },
    {
      id: 14,
      receiptNumber: "R014",
      type: "Refund",
      user: "user1",

      taxAmount: 0.0,
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      discountAmount: 8.0,
      totalAmount: 45.0,
      status: "Paid",
    },
    {
      id: 15,
      receiptNumber: "R015",
      type: "Receipt",
      taxAmount: 6.0,
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      taxRate: 12,
      taxName: "gold",
      user: "user1",

      discountAmount: 2.0,
      totalAmount: 220.0,
      status: "Paid",
    },
    {
      id: 16,
      receiptNumber: "R016",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      user: "user1",

      type: "Receipt",

      taxAmount: 4.0,
      discountAmount: 1.0,
      totalAmount: 160.0,
      status: "Unpaid",
    },
    {
      id: 17,
      receiptNumber: "R017",
      type: "Refund",
      taxRate: 12,
      user: "user1",

      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      taxAmount: 0.0,
      discountAmount: 4.0,
      totalAmount: 25.0,
      status: "Paid",
    },
    {
      id: 18,
      receiptNumber: "R018",
      type: "Receipt",
      taxRate: 12,
      user: "user1",

      taxName: "gold",

      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      taxAmount: 10.0,
      discountAmount: 3.0,
      totalAmount: 500.0,
      status: "Partially Paid",
    },
    {
      id: 19,
      receiptNumber: "R019",
      type: "Receipt",
      user: "user1",

      taxAmount: 7.0,
      discountAmount: 2.0,
      taxRate: 12,
      taxName: "gold",
      totalAmount: 300.0,
      status: "Paid",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      refunditems: [
        {
          id: 104,
          receiptNumber: "R104",
          type: "Refund",
          user: "user1",
          taxAmount: 0.0,
          discountAmount: 3.0,
          totalAmount: 25.0,
          status: "Paid",
          taxRate: 12,
          taxName: "gold",
          created_at: "2024-09-24 10:30:00",
          created_by: "Waqar",
        },
        {
          id: 105,
          receiptNumber: "R105",
          type: "Refund",
          taxAmount: 0.0,
          discountAmount: 1.0,
          totalAmount: 15.0,
          status: "Paid",
          user: "user1",
          taxRate: 12,
          taxName: "gold",
          created_at: "2024-09-25 09:00:00",
          created_by: "Waqar",
        },
      ],
    },
    {
      id: 20,
      receiptNumber: "R020",
      type: "Receipt",
      user: "user1",

      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      taxAmount: 4.5,
      discountAmount: 0.0,
      taxRate: 12,
      taxName: "gold",

      totalAmount: 180.0,
      status: "Unpaid",
    },
    {
      id: 21,
      receiptNumber: "R021",
      type: "Refund",
      user: "user1",

      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      taxAmount: 0.0,
      discountAmount: 6.0,
      taxRate: 12,
      taxName: "gold",

      totalAmount: 30.0,
      status: "Paid",
    },
    {
      id: 22,
      receiptNumber: "R022",
      type: "Receipt",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      taxAmount: 8.0,
      user: "user1",

      discountAmount: 5.0,
      taxRate: 12,
      taxName: "gold",

      totalAmount: 400.0,
      status: "Paid",
    },
    {
      id: 23,
      receiptNumber: "R023",
      type: "Receipt",
      taxRate: 12,
      user: "user1",

      taxName: "gold",

      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      taxAmount: 5.0,
      discountAmount: 1.0,
      totalAmount: 190.0,
      status: "Partially Paid",
    },
    {
      id: 24,
      receiptNumber: "R024",
      user: "user1",

      type: "Receipt",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      taxAmount: 3.0,
      discountAmount: 0.0,
      totalAmount: 120.0,
      status: "Unpaid",
    },
    {
      id: 25,
      receiptNumber: "R025",
      type: "Refund",
      taxRate: 12,
      taxName: "gold",
      created_at: "2024-09-20 08:00:00",
      created_by: "Waqar",
      user: "user1",

      taxAmount: 0.0,
      discountAmount: 7.0,
      totalAmount: 40.0,
      status: "Paid",
    },
  ],
  total_counts: 25,
  filtered_counts: 25,
};
